import React from "react";
import { Text } from "../../atoms/text";

export const FormHeader = ({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) => {
  return (
    <div className="text-center pb-8">
      <h2 className={`text-xl font-semibold text-gray-800 pb-2 ${className}`}>
        {title}
      </h2>
      <Text>{description}</Text>
    </div>
  );
};
